import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/app/[locale]/error.tsx");
